import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const BackArrow = (props) => (
  <Icon viewBox="0 0 37 30" {...props}>
    <g>
      <path d="M15.152 28.625a1.328 1.328 0 0 0 0-1.865L4.455 15.956h31.017c.721 0 1.306-.59 1.306-1.319 0-.728-.585-1.318-1.306-1.318H4.455L15.151 2.515c.51-.515.51-1.35 0-1.865a1.298 1.298 0 0 0-1.846 0L.38 13.705a1.34 1.34 0 0 0 0 1.866l12.925 13.055c.51.514 1.337.514 1.847-.001.509-.515-.51.515 0 0z"
        fill="currentColor" />
    </g>
  </Icon>
);
/*eslint-enable */

export default BackArrow;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/BackArrow.js